export default "__VITE_ASSET__5e716589__"